import styled, { css } from "styled-components/native";

export const StyledContainer = styled.View`
	height: 100vh;
	z-index: -1;
`;

export const StyledOverflow = styled.View`
	height: 100%;
	overflow: scroll;
	padding-left: 20px;
	padding-right: 20px;
`;

export const StyledText = styled.Text`
	font-size: 25px;
	color: white;
`;

export const StyledWrapper = styled.View`
	z-index: -1;
	padding: 0 14.1% 0 14.1%;
`;

export const StyledPadding = styled.View<any>`
	padding-top: 130px;
	${(props) =>
		props.transactionHistory &&
		css`
			padding-top: 50px;
		`}
`;

export const BlurFooter = styled.View`
	width: 100%;
	height: 80px;
	position: absolute;
	bottom: 0;
	background-image: linear-gradient(to bottom, transparent, black);
`;
